import React, { useMemo } from "react";
import { Radio } from "antd";

interface OptionType {
    isRight: boolean;
    description: string;
    key: number;
}

interface JudgeOptionsProps {
    value?: OptionType[];
    onChange?: (value: OptionType[]) => void;
}

export default function JudgeOptions({ value, onChange }: JudgeOptionsProps) {
    const options = value || [];

    const checked = useMemo(() => {
        return options.filter(item => item.isRight).map(item => item.key)?.[0];
    }, [options]);

    function onSelectChange(e: any) {
        const checked = e.target.value;

        const newOptions = options.map(option => {
            const isRight = checked === option.key;
            return { ...option, isRight };
        });
        onChange?.(newOptions || []);
    }

    return (
        <Radio.Group value={checked} onChange={onSelectChange}>
            {options.map(item => (
                <Radio value={item.key} key={item.key}>
                    {item.description}
                </Radio>
            ))}
        </Radio.Group>
    );
}
